import * as React from 'react';

import {Avatar} from 'shells/avatar/avatar';
import {Button} from 'shells/button/button';
import {ChevronDownIcon} from 'shells/icon';
import {Popover} from 'shells/popover/popover';
import {SelectableListSingle} from 'shells/selectable-list/selectable-list';

import type {LeadStagesEdge} from 'nutshell-graphql-types';

type Props = {
    leadStageEdges: LeadStagesEdge[];
    activeStageId: string;
    selectedStageId: string;
    onStageChange: (stageId: string) => void;
};

export function StageSelector(props: Props) {
    const [isPopoverOpen, setIsPopoverOpen] = React.useState<boolean>(false);
    const anchorRef = React.useRef<HTMLElement | null | undefined>(null);

    const stageOptions = React.useMemo(
        () =>
            props.leadStageEdges.map((edge) => ({
                name: edge.node.name + (edge.node.id === props.activeStageId ? ' (Current)' : ''),
                id: edge.node.id,
                icon: <Avatar avatarUrl={edge.chevronAvatarUrl} circular={false} size={16} />,
            })),
        [props.leadStageEdges, props.activeStageId]
    );

    const selectedStageOption = React.useMemo(
        () => stageOptions.find((option) => option.id === props.selectedStageId) || stageOptions[0],
        [stageOptions, props.selectedStageId]
    );

    return (
        <>
            <Button
                variant='text-primary'
                onClick={() => setIsPopoverOpen(true)}
                // @ts-expect-error
                getButtonRef={(ref) => (anchorRef.current = ref)}
                noPadding={true}
                preventUnderline={true}
            >
                {/* @ts-expect-error */}
                {selectedStageOption.name} <ChevronDownIcon size={12} wrapWithDiv={false} />
            </Button>
            {isPopoverOpen && anchorRef.current && (
                <Popover
                    anchor={anchorRef.current}
                    location='bottom'
                    onBlur={() => setIsPopoverOpen(false)}
                >
                    {/* @ts-expect-error */}
                    <SelectableListSingle
                        collection={stageOptions}
                        // @ts-expect-error
                        value={selectedStageOption.id}
                        hasSearch={false}
                        isNewStyle={true}
                        alwaysHasValue={true}
                        // @ts-expect-error
                        sortInitialValueToTop={false}
                        onSelect={(stageId?: string | null) => {
                            setIsPopoverOpen(false);
                            if (stageId) {
                                props.onStageChange(stageId);
                            }
                        }}
                    />
                </Popover>
            )}
        </>
    );
}
